import React from "react";

import style from "../../assets/css/components/Chart/Chart.module.css";
import tinycolor from "tinycolor2";
import ReactApexChart from "react-apexcharts";

function EfficiencyTeam({ teamColor, series }) {
  const options = {
    chart: {
      height: 350,
      type: "radialBar",
      offsetY: -10,
      foreColor: "#fff"
    },
    colors: [
      tinycolor.readability("#17171d", teamColor) <= 2
        ? tinycolor
            .mostReadable("#17171d", ["#00dd80", teamColor])
            .toHexString()
        : teamColor
    ],
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 135,

        track: {
          show: true,
          startAngle: undefined,
          endAngle: undefined,
          background: "#17171d"
        },
        dataLabels: {
          name: {
            show: false
          },
          value: {
            offsetY: 76,
            fontSize: "1.2rem",
            color: { teamColor },
            formatter: function (val) {
              return val + "%";
            }
          }
        }
      }
    },
    fill: {
      color: "#00dd80",
      type: "solid"
    },
    stroke: {
      dashArray: 4
    },
    labels: ["EFECTIVIDAD"]
  };

  return (
    <>
      <ReactApexChart
        className={style.chart}
        options={options}
        series={series}
        type="radialBar"
        width={"100%"}
        height={"100%"}
      />
    </>
  );
}

export default EfficiencyTeam;
